import PropTypes from "prop-types";

import { useGetOrganization } from "@/entities/organization";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import OrganizationEdit from "./OrganizationEdit.component";

const OrganizationEditWrapper = ({ organizationId }) => {
  const { organization, isLoading } = useGetOrganization(organizationId);

  return (
    <FetchItemWrapper
      item={organization}
      loading={isLoading}
      renderContent={(organization) => (
        <OrganizationEdit model={organization} />
      )}
    />
  );
};

OrganizationEditWrapper.propTypes = {
  organizationId: PropTypes.number.isRequired,
};

export default OrganizationEditWrapper;
